import state from '@/assets/common/store/state.js';

const mutations = {
	setNowSystemTime (state, val) {
    state.nowSystemTime = val
	},
	subItemUrlsChange (state, payload) {
    state.subItemUrls = payload
  },
};

for (let key in state) {
	mutations[`SET_${key.toUpperCase()}`] = function(state, value) {
		state[key] = value;
	}
}

export default mutations;
